module.exports = __webpack_public_path__ + "img/add-image9.e7c2a886.png";